export const setBuilderBrandColor = (color: string): void => {
  const root = document.querySelector(":root") as HTMLElement;

  root.style.setProperty("--builder-brand-color", color);
};

export const resetBuilderBrandColor = (): void => {
  setTimeout(() => {
    const primary = "#8f00ff";
    const root = document.querySelector(":root") as HTMLElement;

    root.style.setProperty("--builder-brand-color", primary);
  });
};
